import { atom } from "jotai";
import { Node } from "@xyflow/react";
import { selectedNodesAtom } from "./selectedNodesAtom";

/* Please don't use this and instead create fine-grained selectors from it.

   When performing a coarse-grained read, the component becomes dependent on the entire piece of state and
   will re-render when any part of it changes. If the component only needs a few attributes, then we’re performing
   needless rendering when the unused attributes change.

   See: https://docs.k8s.zapier.com/editor/Architecture/StateManagement/Jotai/Patterns.html#prefer-using-fine-grained-selectors
*/
const singleSelectedNodeAtom = atom<Node | null>((get) => {
  const selectedNodes = get(selectedNodesAtom);
  if (selectedNodes && selectedNodes.length === 1) {
    return selectedNodes[0];
  }

  return null;
});
singleSelectedNodeAtom.debugLabel = "singleSelectedNodeAtom";

export const singleSelectedNodeIdAtom = atom<string | undefined>((get) => {
  const singleSelectedNode = get(singleSelectedNodeAtom);
  return singleSelectedNode?.id;
});
singleSelectedNodeIdAtom.debugLabel = "singleSelectedNodeIdAtom";

export const singleSelectedNodeTypeAtom = atom<string>((get) => {
  const singleSelectedNode = get(singleSelectedNodeAtom);
  return singleSelectedNode?.type ?? "";
});
singleSelectedNodeTypeAtom.debugLabel = "singleSelectedNodeTypeAtom";
